import { useEffect, useRef } from 'react';
export function useCurrentRef(toRef) {
    var toRefRef = useRef(toRef);
    useEffect(function () {
        toRefRef.current = toRef;
    });
    return toRefRef;
}
